import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('dtWalletUser');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return !!localStorage.getItem('dtWalletUser');
    });

    useEffect(() => {
        if (user) {
            localStorage.setItem('dtWalletUser', JSON.stringify(user));
            setIsAuthenticated(true);
        } else {
            localStorage.removeItem('dtWalletUser');
            setIsAuthenticated(false);
        }
    }, [user]);

    const login = (email, password) => {
        const TEST_EMAIL = 'test@dtwallet.com';
        const TEST_PASSWORD = 'test123';

        if (email === TEST_EMAIL && password === TEST_PASSWORD) {
            const userData = {
                email: email,
                name: 'Test User',
                id: 1
            };
            setUser(userData);
            return { success: true, user: userData };
        }
        return { success: false, error: 'Invalid email or password' };
    };

    const logout = () => {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('dtWalletUser');
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                isAuthenticated,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
